import { PDFDocument } from 'pdf-lib';

export async function mergeBlobUrls(blobUrls, filename = "merged.pdf") {
  // Create a new PDF
  const mergedPdf = await PDFDocument.create();

  for (const url of blobUrls) {
    // Fetch blob from blob: URL
    const response = await fetch(url);
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();

    // Load the PDF
    const pdf = await PDFDocument.load(arrayBuffer);

    // Copy all pages from current PDF into merged PDF
    const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
    pages.forEach((page) => mergedPdf.addPage(page));
  }

  // Save merged PDF
  const mergedPdfBytes = await mergedPdf.save();

  // Convert to Blob and trigger download
  const mergedBlob = new Blob([mergedPdfBytes], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(mergedBlob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}